<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <InputSearch v-model="filtro_text" placeholder="Pesquise " @updateSearch="reloadGrid" />
                </div>
            </div>
            <div class="row ms-3 me-3 datatable-usuarios mt-3">                
                <DataTable :url_ajax="getUrlUsuarios()" :ajax_set_result="setUsuario" @grid_refreshed="gridRefreshed" :request_api="'comercial'"
                           :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                           :footer_fixed="true" :headers="headers" :pBtnsSlot="true" :is_modal="true"
                           customHeight="max-height: calc(100vh - 29rem); min-height: calc(100vh - 29rem);" customHeightPaginate="min-height: calc(100vh - 29rem);  max-height: calc(100vh - 29rem); " :column_slot="true">
                    <template v-slot:cell-slot_nmUsuario="item">
                        <div>
                            <span>{{ item.row.nmUsuario }}</span>
                            <span v-if="item.row.flSupervisor == 'Sim'" style="margin-left:15px;" class="selo">                                
                                S
                                <span style="min-width: 200px; transform: translateY(-43px);">
                                    <b style="display: inline; transform: translateY(-43px);">Supervisor</b>
                                </span>                                
                            </span>
                        </div>
                    </template>
                    <template v-slot:BtnSlot="item">
                        <button type="button" class="btn-grid-editar-lista btn-Ligar" @click="ligar(item.row.idPessoa)" v-if="flContato == false && item.row.idPessoa > 0">
                            <i class="fas fa-phone" aria-hidden="true"></i><span class="btn-span-text">Ligar</span>
                        </button>
                        <span v-else>
                            Cadastro pessoa não realizado.
                        </span>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <modal-warper target="Ligacao_Crud" :show="isOpenModalLigacaoCrud" @close="(isOpenModalLigacaoCrud = false)" v-if="flContato == false">
        <component :is="LigacaoCrudC"  v-bind="{ idOcorrencia, idPessoa, show: isOpenModalLigacaoCrud, idInstituicao, idModulo }" @ReloadGrid="fechouModalLigacao" v-if="flContato == false"></component>        
    </modal-warper>

</template>

<script>

    import axios from 'axios';
    import DataTable from '../../../../components/App/Datatable.vue'
    import OcorrenciaInfo from '../../../../components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import InputSearch from '../../../../components/App/Input_Search.vue'
    import ModalWarper from './../../../../components/App/ModalWarper.vue'
    import { shallowRef } from 'vue';
    /*import $ from 'jquery';*/

    export default {
        name: 'Usuários',
        components: {
            InputSearch,
            DataTable,
            OcorrenciaInfo,
            ModalWarper
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            flContato: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                LigacaoCrudC: shallowRef(null),

                ocorrencia: {},

                headers: [
                    { class: 'col-2', name: 'nmUsuario', text: 'Nome', order: 0, slot: true },
                    { class: 'col-2', name: 'dsLogin', text: 'E-mail', order: 0 },
                    { class: 'col-2 text-center', name: 'qtdContatosPorContrato', text: 'Contatos Contrato', order: 0 },
                    { class: 'col-1 text-center', name: 'qtdContatos', text: 'Contatos', order: 0 },
                    { class: 'col-2 text-center', name: 'qtdUtilizacoesPorContrato', text: 'Utilizações Contrato', order: 0 },
                    { class: 'col-1 text-center', name: 'qtdUtilizacoes', text: 'Utilizações', order: 0 },
                    { class: 'col-1', name: 'dtUltimoLogin', text: 'Último Acesso', order: 0 },
                    { class: 'col-1', name: 'btns', text: '', actions: true }
                ],

                refresh_grid: false,
                refresh_gridAnexo: false,
                filtro: [
                    { active: true },
                ],

                busca: '',

                NotLoading: false,
                filtro_text: '',

                isOpenModalLigacaoCrud: false,
                idPessoa: 0,
                idInstituicao: 0,
                idModulo: 0

            }
        },
        computed: {},
        methods: {
            fechouModalLigacao() {
                this.isOpenModalLigacaoCrud = false;
            },
            async loadLigacaoCrud() {
                try {
                    const component = await import('@/views/Modais/Ocorrencia/Modais/Ligacao_Crud.vue');
                    this.LigacaoCrudC = component.default;
                } catch (error) {
                    console.error('Erro ao carregar LigacaoCrud:', error);
                }
            },

            ligar(idPessoa) {
                let $this = this;

                $this.idPessoa = idPessoa;
                $this.isOpenModalLigacaoCrud = true;

                var myModal = new window.bootstrap.Modal(document.getElementById('Ligacao_Crud'));
                myModal.show();

                /*$("#Ligacao_Crud").modal('show');*/
            },


            setUsuario(result) {
                return result;
            },

            gridRefreshed(data_ajax) {
                let $this = this;

                $this.NotLoading = false;
                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;

                $this.NotLoading = false;
                $this.refresh_grid = true;
            },

            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.idModulo = $this.ocorrencia.idModulo;
                    $this.idInstituicao = $this.ocorrencia.idInstituicao;

                    if (!$this.flContato) {
                        $this.initializeComponent();
                    }
                })
            },
            getUrlUsuarios() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/ClienteUsuario/GetUsuariosContratoOcorrencias?idOcorrencia=' + $this.idOcorrencia;
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
            async initializeComponent() {
                await this.loadLigacaoCrud();
            }

        },
        created() {
            //if (!this.flContato) {
            //    console.log('carregou o compoennte 1');
            //    this.initializeComponent();
            //}
        },
        mounted() {
            this.getOcorrencia();

        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
                this.reloadGrid();
            },
            flContato(val) {
                //if (!val && !this.LigacaoCrud) {
                //    console.log('carregou o compoennte 2');
                //    this.initializeComponent();
                //}
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;

                $this.NotLoading = true;
                $this.filtro[0].value = newVal;
                $this.refresh_grid = true;
            },
        },
    }

</script>

<style lang="scss">

    .datatable-usuarios .body-class-personalizada {
        height: calc(100vh - 29rem) !important;
    }

    .selo {
        color: white;
        background: darkorange;
        display: inline-block;
        cursor: pointer;
        position: relative;
        text-align: center;
        font-size: 11px;
        margin: 0px;
        padding: 0px;
        min-width: 22px;
        font-weight: bold;
    }

    .selo:hover:before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #900;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    .selo > span {
        visibility: hidden;
        font-size: 12px;
        min-width: 160px;
        width: auto;
        position: absolute;
        background-color: #900;
        color: #fff;
        text-align: center;
        border-radius: 3px;
        padding: 3px 10px;
        z-index: 1;
        top: 40px;
        left: 0;
        box-shadow: 0 0 10px 3px rgba(0, 0, 0, .2);
    }

    .selo:hover > span {
        visibility: visible;
    }

    .selo:hover {
        background: #900;
    }
</style>